<template>
  <div
    class="modal"
    :class="style.container"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    v-modal
  >
    <div :class="style.modal" role="document">
      <div class="modal-content" :class="style.content">
        <div
          class="modal-header sub-page bg-white type01"
          v-if="display.header"
          :class="style.header"
        >
          <div class="page-title pb-0" :class="style.title">
            <slot name="backBtn" v-if="display.back">
              <a
                class="btn page-back"
                data-dismiss="modal"
                aria-label="Close"
                href="javascript:void(0)"
                ><i class="fa fa-angle-left"></i
              ></a>
            </slot>
            <slot name="title">
              <p class="h6 title" v-text="text.title" v-if="text.title"></p>
            </slot>
            <slot name="closeBtn" v-if="display.close">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true"></span>
              </button>
            </slot>
          </div>
        </div>
        <div class="modal-body" :class="style.body">
          <slot name="contents"></slot>
        </div>
        <slot name="footer" v-if="display.footer">
          <div class="modal-footer" :class="style.footer">
            <div class="d-flex">
              <button
                type="button"
                class="btn btn-cancel text-color6 px-3 py-0"
                :class="style.cancel"
                v-if="display.cancel"
                :data-dismiss="dismiss.cancel ? 'modal' : ''"
                @click.prevent="$emit('cancel')"
                v-text="text.cancel"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-confirm text-color4 px-3 py-0"
                :class="style.confirm"
                v-if="display.confirm"
                :data-dismiss="dismiss.confirm ? 'modal' : ''"
                @click.prevent="$emit('confirm')"
                v-text="text.confirm"
              ></button>
            </div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'VueModal',
    directives: {
        modal: {
            inserted: function(e, binding, vnode) {
                let $this = $(e);
                let context = vnode.context;
                $this.on('shown.bs.modal', function() {
                    context.$emit('show');
                });
                $this.modal('show');
                $this.on('hidden.bs.modal', function() {
                    context.$emit('close');
                });
            },
            unbind: function(e) {
                $(e).modal('hide');
            },
        },
    },
    props: ['options'],
    data() {
        return $utils.deepExtend(
            {
                text: {
                    confirm: '확인',
                    cancel: '취소',
                    title: '알림',
                },
                display: {
                    header: true,
                    close: true,
                    back: false,
                    title: true,
                    footer: true,
                    confirm: true,
                    cancel: true,
                    backdrop: true,
                },
                data: {
                    backdrop: false,
                },
                dismiss: {
                    confirm: true,
                    cancel: true,
                },
                style: {
                    container: 'lemoncare-modal',
                    modal: 'modal-dialog modal-dialog-centered',
                    header: '',
                    title: '',
                    content: '',
                    confirm: '',
                    cancle: '',
                },
            },
            this.options,
        );
    },
    methods: {},
};
</script>

<style>
</style>
